import MenuContainer from './MenuContainer';
import SearchSelect from '@/components/UI/SearchSelect';
import Button from '@/components/UI/Button/Button';
import { useTableContext } from '@/components/UI/Table/TableContext';
import MetricChangeFrom from '@/components/UI/MetricChangeFrom';
import { FC } from 'react';

interface UseTableShowMenuProps {
  closeMenu: () => void;
  showMetricChangeFrom?: boolean;
  tableName: string;
  hasSelectorColumn?: boolean;
}

interface ColumnInfo {
  id: string;
  Header: string;
  isVisible?: boolean;
}

/** Column IDs that should not appear in the show/hide menu */
const SYSTEM_COLUMN_IDS = new Set(['selection', 'actions']);

const UseTableShowMenu: FC<UseTableShowMenuProps> = ({
  closeMenu,
  showMetricChangeFrom = false,
  hasSelectorColumn = false,
}) => {
  const context = useTableContext();
  const allColumns = (context.allColumns ?? []) as Array<ColumnInfo>;
  const visibleColumns = (context.visibleColumns ?? []) as Array<ColumnInfo>;
  const toggleHideColumn = context.toggleHideColumn as (columnId: string, hide?: boolean) => void;
  const toggleHideAllColumns = context.toggleHideAllColumns as (hide: boolean) => void;

  const toggleColumn = (value: string) => {
    toggleHideColumn(value);
  };

  const toggleAll = (show: boolean) => {
    toggleHideAllColumns(!show);
    // Keep system columns visible
    if (hasSelectorColumn) {
      toggleHideColumn('selection', false);
    }
    toggleHideColumn('actions', false);
  };

  const isUserColumn = ({ id }: ColumnInfo) => !SYSTEM_COLUMN_IDS.has(id);

  return (
    <MenuContainer width={300}>
      {showMetricChangeFrom && <MetricChangeFrom />}
      <SearchSelect
        sections={[
          {
            title: 'All fields',
            items: allColumns.filter(isUserColumn).map(({ id, Header }) => ({
              id,
              title: Header,
            })),
          },
        ]}
        overflowHeight={300}
        selected={visibleColumns.filter(isUserColumn).map((col) => col.id)}
        onSelect={({ value }: { value: string }) => toggleColumn(value)}
        onClearSelection={() => toggleAll(false)}
        onSelectAll={() => toggleAll(true)}
      />
      <div className="bt b--moon-gray pa3">
        <Button onClick={closeMenu} plain className="f6 w-100" testId="show-menu-close-button">
          Close
        </Button>
      </div>
    </MenuContainer>
  );
};

export default UseTableShowMenu;
